import * as React from "react";
import { Button, Edit, ReferenceInput, SelectInput, TextInput, Toolbar, required, useNotify } from "react-admin";
import { TitleHomebaseComponent } from "./Constant/Constant";
import { CircularProgress, Grid } from "@material-ui/core";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { Add } from "@material-ui/icons";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { useAppDataProvider } from "../../../dataprovider";

const HomebaseComponentEdit = props => {
  const notify = useNotify();
  const history = useHistory();
  const dataProvider = useAppDataProvider();
  const [loading, setLoading] = React.useState<boolean>(false);
  const onFailure = error => notify(error?.response?.data, { type: "warning" });
  const onChangeCustomer = form => e => {
    form.change("warehouseId", null);
  };
  const onSubmit = values => {
    if (loading) {
      return;
    }
    setLoading(true);
    dataProvider
      .getHomeBaseComponent(props.id)
      .then(response => {
        var request = { ...response.data, ...values };
        dataProvider
          .updateHomeBaseComponent(request)
          .then(response => {
            notify(`Record updated`, "success", false, true);
            history.push("/homebasecomponents");
          })
          .catch(response => {
            notify(`${response}`, "error", false, true);
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(response => {
        notify(`${response}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, form, values }) => {
        return (
          <form>
            <>
              <Edit {...props} title={TitleHomebaseComponent.edit}>
                <Grid container spacing={2} style={{ width: "100%", padding: 30 }}>
                  <Grid item xs={12} sm={6}>
                    <ReferenceInput
                      label="Customer"
                      source="customerId"
                      reference={SourceCustomer}
                      sort={{ field: "id", order: "ASC" }}
                      validate={[required()]}
                      fullWidth
                      variant="outlined"
                      onChange={onChangeCustomer(form)}
                    >
                      <SelectInput optionValue="id" optionText="customerName" />
                    </ReferenceInput>
                    <TextInput source="pn" validate={[required()]} fullWidth variant="outlined" disabled />
                    <TextInput source="condition" validate={[required()]} fullWidth variant="outlined" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ReferenceInput
                      disabled={!(values.customerId > 0)}
                      label="Warehouse"
                      source="warehouseId"
                      reference={"homebasewarehouses"}
                      filter={{ customerId__eq: values.customerId ?? null }}
                      sort={{ field: "id", order: "ASC" }}
                      validate={[required()]}
                      fullWidth
                      variant="outlined"
                      defaultValue={values.warehouseId}
                    >
                      <SelectInput optionValue="id" optionText="location" />
                    </ReferenceInput>
                    <TextInput source="sn" validate={[required()]} fullWidth variant="outlined" disabled />
                  </Grid>
                  <Toolbar
                    {...props}
                    placeholder=""
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >
                    <Button
                      label={loading ? "Updating!" : "Update"}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </Grid>
              </Edit>
            </>
          </form>
        );
      }}
    />
  );
};

export default HomebaseComponentEdit;
